
<question-title [question]="question"></question-title>
<div class="spread">
    <question-verses [question]="question" [config]="config"></question-verses>
    <student-question-button 
        [profile]="profile" 
        [question]="question" 
        [config]="config"></student-question-button>
</div>


<question-instructions [question]="question" [config]="config"></question-instructions>
<question-verse-prompts [question]="question" [config]="config" [(allCorrect)]="allCorrect"></question-verse-prompts>